import { ref,reactive } from 'vue'
import axios from "axios";
import { useRoute } from 'vue-router';

export default function useVideo() {
    const videos = ref([])
    const video = ref({})
    const meta = reactive({});
    const route = useRoute()
    const loading = ref(true)
    const errors = ref('')

    const getVideos = async (p = 1) => {
        try {
            errors.value = '';
            loading.value = true;
            let response = await axios.get('video/'+ route.name.replace('video.','') +'?page=' + p);
            loading.value = false;
            Object.assign(meta, response.data.meta);
            videos.value.push(...response.data.data);
        }catch (e){
            errors.value = e;
            loading.value = false;
        }
    }

    return {
        errors,
        loading,
        meta,
        route,
        getVideos,
        videos,
        video,
    }
}